import api from '@/client/axiosInstance';
import { AxiosError } from 'axios';

export const generateCsrfToken = async (): Promise<string> => {
  try {
    // The axios instance is already configured with the backend base URL,
    // so we should only call the relative path here to avoid double base URLs.
    const response = await api.get('security/csrf-token');
    const token = response.data?.csrfToken as string;

    if (!token || typeof token !== 'string') {
      throw new Error('CSRF token response is invalid');
    }

    sessionStorage.setItem('csrfToken', token);
    return token;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
          'Something went wrong. Please try again.',
      );
    }
    throw new Error('Unknown error occurred');
  }
};
